export enum ErrorCodes {
  EVENT_TOO_MANY_OCCURRENCES = 'too-many-event-occurrences',
  EVENT_TOO_FEW_OCCURRENCES = 'too-few-event-occurrences',
  TEAM_NAME_ALREADY_EXISTS = 'team-name-already-exists',
  ATTRIBUTE_NAME_ALREADY_EXISTS = 'company-attribute-label-already-exists',
  ATTRIBUTE_VALUE_NAME_ALREADY_EXISTS = 'company-attribute-value-already-exists',
}
